import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { differenceInDays } from "date-fns";
import { ShieldAlert } from "lucide-react";
import { useTRPC } from "@/lib/trpc";

export default function SubscriptionNudge() {
    const trpc = useTRPC();
    // We don't use the default useSubscription hook because we want to refetch the subscription data every 3 minutes.
    const { data: subscriptionData, isLoading } = useQuery(
        trpc.subscription.get.queryOptions(
            {},
            {
                staleTime: 10 * 1000, // 10 seconds. We ask this thing a couple of times in a row when loading, so we cache it for a couple of seconds to avoid refetching.
                gcTime: 10 * 1000, // 10 seconds
                refetchOnWindowFocus: true,
                refetchInterval: 3 * 60 * 1000, // every 3 minutes
            }
        )
    );

    const hasSubscription = !!subscriptionData?.subscription;
    let trialDaysLeft = subscriptionData?.trialEndsAt ? differenceInDays(subscriptionData?.trialEndsAt, new Date()) : 0;
    trialDaysLeft = trialDaysLeft < 0 ? 0 : trialDaysLeft;

    if (isLoading || hasSubscription) {
        return null;
    }

    return (
        <Link
            to="."
            search={{ settings: "subscription" }}
            className="bg-slate-500/70 text-white border  hover:bg-slate-500/80 ml-2 mb-2 p-2 rounded-sm flex items-start gap-2"
        >
            <ShieldAlert className="size-4.5" />
            <div>
                {trialDaysLeft} {trialDaysLeft === 1 ? "day" : "days"} left on your free trial.{" "}
                <span className="font-medium">Upgrade now</span>
            </div>
        </Link>
    );
}
